import React from 'react';
import Card from "../Card/Card";
import { RetentionActionLabels, RetentionTriggerEventLabels } from "../../Constants/Gdpr/GdprConstants";
import {useSelector} from "react-redux";

function GdprRetentionPoliciesTable({ policies }) {
    const isLoading = useSelector(state => state.CommonReducer?.dataLoading.gdpr_retention_policies);
    
    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>Retention Policies</Card.Header.Title>
            </Card.Header>
            <Card.Content isLoading={isLoading}>
                <div className="table-responsive">
                    <table className="table table-stripe skynet-table-no-divider">
                        <thead>
                            <tr>
                                <th>Action</th>
                                <th>Days After</th>
                                <th>Event</th>
                                <th>Status</th>
                                <th>Data Types</th>
                            </tr>
                        </thead>
                        <tbody>
                            {policies?.map(policy => (
                                <tr key={policy.id}>
                                    <td>{RetentionActionLabels[policy.action]}</td>
                                    <td>{policy.daysAfter} days</td>
                                    <td>{RetentionTriggerEventLabels[policy.triggerEvent]}</td>
                                    <td>{policy.enabled ? 'Enabled' : 'Disabled'}</td>
                                    <td>{policy.dataTypes?.join(', ')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Card.Content>
        </Card>
    );
}

export default GdprRetentionPoliciesTable;

